import { useId } from 'react'
import './Switch.css'

export type SwitchProps = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  /** Extra explanation under the label. */
  description?: string
}

export function Switch({ label, checked, onChange, description }: SwitchProps) {
  const id = useId()
  const descriptionId = `${id}-description`
  return (
    <div className="ui-switch">
      <span className="ui-switch__text">
        <label className="ui-switch__label" htmlFor={id}>
          {label}
        </label>
        {description && (
          <span className="ui-switch__description" id={descriptionId}>
            {description}
          </span>
        )}
      </span>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-describedby={description ? descriptionId : undefined}
        className="ui-switch__track"
        onClick={() => onChange(!checked)}
      >
        <span className="ui-switch__thumb" aria-hidden="true" />
      </button>
    </div>
  )
}
